import { render, staticRenderFns } from "./RelatedPayOrdersViewer.vue?vue&type=template&id=58bc2930&scoped=true&"
import script from "./RelatedPayOrdersViewer.vue?vue&type=script&lang=js&"
export * from "./RelatedPayOrdersViewer.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPayOrdersViewer.vue?vue&type=style&index=0&id=58bc2930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc2930",
  null
  
)

export default component.exports